import { useGetTeamMemberCertificationAggregationsByStatusQuery } from '../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/MyTeamChirpService.hooks';
import { useGetCertificationAggregationsByStatusQuery } from '../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/MyTeamChirpService.hooks';
import { useGetPortalAggregationsQuery } from '../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/MyTeamChirpService.hooks';
import { useGetIndividualCertificationOverviewQuery } from '../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/MyTeamChirpService.hooks';
import { useGetCertificationMetadataQuery } from '../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/CertificationChirpService.hooks';
import { useGetTeamMembersCertificationsByStatusQuery } from '../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/MyTeamChirpService.hooks';
// transfer certs modal
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import http from 'hub-http/clients/apiClient';
// Portals with a large number of users can take longer than the default 5s to load, so we need to increase the timeout
const DEFAULT_TIMEOUT = 10000;
export const useRecentCertifications = () => {
  const {
    data,
    loading,
    error
  } = useGetTeamMembersCertificationsByStatusQuery({
    variables: {
      certificationStatus: 'ACTIVE',
      offset: {
        offsetPosition: 0
      },
      pageLength: 25,
      sortField: 'COMPLETED_AT',
      sortOrder: 'DESC',
      tools: []
    },
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    recentCertifications: data === null || data === void 0 ? void 0 : data.results,
    recentCertificationsLoading: loading,
    recentCertificationsError: error
  };
};
export const useUpcomingExpirations = () => {
  const {
    data,
    loading,
    error
  } = useGetTeamMembersCertificationsByStatusQuery({
    variables: {
      certificationStatus: 'ACTIVE',
      offset: {
        offsetPosition: 0
      },
      pageLength: 25,
      sortField: 'EXPIRES_AT',
      sortOrder: 'ASC',
      tools: []
    },
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    upcomingExpirations: data === null || data === void 0 ? void 0 : data.results,
    upcomingExpirationsLoading: loading,
    upcomingExpirationsError: error
  };
};
export const useCertificationInfo = (certificationId, language) => {
  const {
    data,
    loading,
    error
  } = useGetCertificationMetadataQuery({
    variables: {
      certificationId,
      language
    }
  });
  return {
    certificationInfo: data === null || data === void 0 ? void 0 : data.metadata,
    certificationInfoLoading: loading,
    certificationInfoError: error
  };
};
export const useIndividualCertificationOverview = params => {
  const {
    offset,
    certificationStatus,
    certificationId,
    teamIds = [],
    userIds = [],
    nameFilter,
    sortOrder,
    sortField,
    pageLength = 10
  } = params;
  const {
    data,
    loading,
    error
  } = useGetIndividualCertificationOverviewQuery({
    variables: {
      certificationId,
      certificationStatus,
      teamIds,
      userIds,
      nameFilter: nameFilter || undefined,
      sortOrder: sortOrder || undefined,
      sortField: sortField || undefined,
      pageLength: pageLength || undefined,
      pageSize: pageLength,
      offset
    },
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    data,
    loading,
    error
  };
};
export const usePortalAggregations = () => {
  const {
    data,
    loading,
    error
  } = useGetPortalAggregationsQuery({
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    portalAggregations: data,
    portalAggregationsLoading: loading,
    portalAggregationsError: error
  };
};
export const useTopCertifications = () => {
  const {
    data,
    loading,
    error
  } = useGetCertificationAggregationsByStatusQuery({
    variables: {
      pageLength: 25,
      offset: {
        offsetPosition: 0
      },
      certificationStatuses: ['ACTIVE'],
      sortOrder: 'DESC',
      sortField: 'ACTIVE',
      tools: []
    },
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    topCertifications: data === null || data === void 0 ? void 0 : data.results,
    topCertificationsLoading: loading,
    topCertificationsError: error
  };
};
export const useCertificationAggregationsByStatus = ({
  pageLength,
  offset,
  sortOrder,
  sortField,
  certificationNameFilter,
  categories,
  tools,
  teamIds,
  userIds,
  preferredLanguage,
  certificationStatuses
}) => {
  const {
    data,
    loading,
    error
  } = useGetCertificationAggregationsByStatusQuery({
    variables: {
      pageLength,
      offset,
      sortOrder,
      sortField,
      certificationNameFilter,
      categories,
      teamIds,
      userIds,
      preferredLanguage,
      tools,
      certificationStatuses
    },
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    certificationAggregationsByStatus: data,
    certificationAggregationsByStatusLoading: loading,
    certificationAggregationsByStatusError: error
  };
};
export const useCurrentUserCertificationsByStatus = ({
  currentUserId,
  categories,
  tools
}) => {
  const {
    data,
    loading,
    error
  } = useGetTeamMemberCertificationAggregationsByStatusQuery({
    variables: {
      userIds: [currentUserId || 1],
      // the query will skip if userId is not provided
      categories,
      tools,
      offset: {
        offsetPosition: 0
      },
      pageLength: 1,
      excludeCurrentUser: false
    },
    skip: !currentUserId,
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    currentUserCertifications: data === null || data === void 0 ? void 0 : data.results[0],
    // should be only one result: the current user
    currentUserCertificationsLoading: loading,
    currentUserCertificationsError: error
  };
};
export const useTeamMembersCertificationAggregationsByStatus = ({
  pageLength,
  offset,
  sortOrder,
  sortField,
  teamMemberNameFilter,
  userIds,
  teamIds,
  categories,
  tools,
  excludeCurrentUser,
  certificationStatuses
}) => {
  const {
    data,
    loading,
    error
  } = useGetTeamMemberCertificationAggregationsByStatusQuery({
    variables: {
      offset,
      pageLength,
      teamIds,
      userIds,
      categories,
      tools,
      sortField: sortField,
      sortOrder,
      teamMemberNameFilter,
      excludeCurrentUser,
      certificationStatuses
    },
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    teamMembersData: data,
    teamMembersDataLoading: loading,
    teamMembersDataError: error
  };
};
export const useTeamMembersCertificationsByStatus = ({
  pageLength,
  offset,
  sortOrder,
  sortField,
  teamMemberNameFilter,
  certificationStatus,
  teamIds,
  userIds,
  categories,
  tools
}) => {
  const {
    data,
    loading,
    error
  } = useGetTeamMembersCertificationsByStatusQuery({
    variables: {
      pageLength,
      offset,
      sortOrder,
      sortField,
      teamMemberNameFilter,
      certificationStatus,
      teamIds,
      userIds,
      categories,
      tools
    },
    context: {
      timeout: DEFAULT_TIMEOUT
    }
  });
  return {
    teamMembersCertifications: data,
    teamMembersCertificationsLoading: loading,
    teamMembersCertificationsError: error
  };
};
const GET_ALL_AWARDS_BY_TRACK = registerQuery({
  fieldName: 'awardsByAsset',
  args: [],
  fetcher() {
    return http.get(`/academy/learning-center/progress/v1/team/awards`);
  }
});
export const useAwardsByTrack = ({
  skip
} = {}) => {
  const {
    data: awardsByTrackResponse,
    loading: awardsByTrackLoading,
    error: awardsByTrackError
  } = useQuery(GET_ALL_AWARDS_BY_TRACK, {
    skip
  });
  const awardsByTrack = awardsByTrackResponse ? awardsByTrackResponse.trackToTeamAwardsMap : null;
  return {
    awardsByTrack,
    awardsByTrackLoading,
    awardsByTrackError
  };
};